// extracted by mini-css-extract-plugin
export var quillEditor = "_q2-1";
export var variable = "_q2-0";